import { API_ENDPOINTS } from "@utils/api/endpoints";
import { getDeviceInfo } from "@utils/get-device-info";
import { useAuthStore } from '@stores/auth';

export default async function (fcmToken = null) {
  const { ssrContext } = useNuxtApp();
  const config = useRuntimeConfig();
  const auth = useAuthStore();

  if (config.public.maintenanceMode) {
    return null;
  }

  if (fcmToken) {
    if (auth.fcmToken) {
      return auth.me;
    }
    auth.setFcmToken(fcmToken);
  }

  const userAgent = import.meta.client ? navigator.userAgent : ssrContext.userAgent;
  const routeLang = useRouteLang();
  const params = Object.assign(
    {},
    { locale: routeLang.locale.value },
    getDeviceInfo(userAgent, routeLang.locale.value),
    fcmToken ? { fcmToken } : {}
  );

  try {
    const data = await $fetch(API_ENDPOINTS.HEARTBEAT, {
      method: 'GET',
      params
    });

    auth.setData(data);

    return data;
  } catch (error) {
    sentryCaptureEvent({
      message: 'load-me',
      level: 'error',
      extra: { error }
    });

    return null;
  }
}
